import { Environment } from '@/constants';
import { CONSTANT } from '@/helpers';
import { useGetUserPlanQuery } from '@/redux/api/api.caller';
import { tokenSelector } from '@/redux/features/auth.slice';
import planSlice, { accountSelector, christmasBannerSelector } from '@/redux/features/plan.slice';
import { DiscountType } from '@/types/account';
import { Frame } from '@shopify/polaris';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import Sidebar from './Sidebar';
import { StyledContentLayout } from './styled';

const AdminLayout = () => {
  const dispatch = useDispatch();
  const account = useSelector(accountSelector);
  const { token } = useSelector(tokenSelector);
  const christmasBanner = useSelector(christmasBannerSelector);

  const { data } = useGetUserPlanQuery({});

  const renderNavigationApp = () => {
    const isOpenFromCMS = token?.scope === 'omegatheme';
    const isNotEmbeddedApp = !CONSTANT.isEmbedded && process.env.REACT_APP_ENV === Environment.Local;

    if (isOpenFromCMS || isNotEmbeddedApp) {
      return <Sidebar />;
    }

    return undefined;
  };

  useEffect(() => {
    if (data && data.data) {
      const { plan, subscription, isOldPaidUser, isOldUser, isEnabledReview, discount, shopId } = data.data;
      const featureDiscount = discount.find((item) => item.type === DiscountType.Feature);

      dispatch(
        planSlice.actions.handleChangePlan({
          ...account,
          plan,
          subscription,
          isOldPaidUser,
          isOldUser,
          isEnabledReview,
          shopId,
        }),
      );

      dispatch(
        planSlice.actions.handleChangeChristmasBanner({
          ...christmasBanner,
          startDate: dayjs(featureDiscount?.startTime).format('MMM DD, YYYY'),
          endDate: dayjs(featureDiscount?.expireTime).format('MMM DD, YYYY'),
          formattedEndDate: new Date(featureDiscount?.expireTime || ''),
          isShow: !!featureDiscount,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Frame navigation={renderNavigationApp()}>
      <StyledContentLayout>
        <div className="main-content">
          <Outlet />
        </div>
        <Footer />
        <ScrollToTop />
      </StyledContentLayout>
    </Frame>
  );
};

export default AdminLayout;
